import { Box, Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Vivia from "../images/viviaDefiniation.png";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const ViviaDefiniation = forwardRef((props, ref) => {
  const { t } = useTranslation();
  return (
    <Box ref={ref} sx={{ scrollMarginTop: "80px" }}>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
          gap: 5,

          background:
            "radial-gradient(39.87% 39.87% at 50% 50%, #0C3247 0%, #081525 100%)",
          pt: 2,
          pb: 3,
        }}
      >
        <Grid>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: 900,
              fontSize: "28px",
              lineHeight: "52px",
              letterSpacing: "10%",
              textAlign: "center",
              verticalAlign: "middle",
              color: "#FFF",
            }}
          >
            {t("Transforming smart cities")}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: 900,
              fontSize: { sx: "35px", md: "36px", lg: "39px" },
              lineHeight: "52px",
              letterSpacing: "10%",
              textAlign: "center",
              verticalAlign: "middle",
              color: "#FFF",
            }}
          >
            {t("with AI, IoT, and cloud-based automation")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // mt: 6,
            // height: 300,
          }}
        >
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              background:
                "linear-gradient(360deg, #1F8FCE 5.13%, #33BBA4 100%)",
              width: "3px",
              mr: 6,
            }}
          />
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontWeight: 450,
              fontSize: "20px",
              lineHeight: "31px",
              letterSpacing: { xs: "1%", md: "3%" },
              textAlign: "justify",
              color: "#FFF",
              width: { sm: "70%", md: "60%" },
            }}
          >
            {t("viviaBreaf")}
          </Typography>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              background:
                "linear-gradient(360deg, #1F8FCE 5.13%, #33BBA4 100%)",
              width: "3px",
              ml: 6,
            }}
          />
        </Grid>

        <Box
          component="img"
          justifyContent="center"
          src={Vivia}
          alt="Vivia"
          style={{
            maxWidth: "75%",
            height: "auto",
            transition: "transform 0.3s ease",
          }}
        />

        <Divider
          sx={{
            borderColor: "linear-gradient(360deg, #1F8FCE 5.13%, #33BBA4 100%)",
            background: "linear-gradient(360deg, #1F8FCE 5.13%, #33BBA4 100%)",
            height: "3px",
            width: "60%",
            mt: 3,
          }}
        />
      </Grid>
    </Box>
  );
});

export default ViviaDefiniation;
